// Import all Vertical Nav components and export them
import Menu from '../components/vertical-menu/Menu'
import SubMenu from '../components/vertical-menu/SubMenu'
import MenuItem from '../components/vertical-menu/MenuItem'
import NavHeader from '../components/vertical-menu/NavHeader'
import VerticalNav from '../components/vertical-menu/VerticalNav'
import MenuSection from '../components/vertical-menu/MenuSection'

export default VerticalNav
export { Menu, MenuItem, SubMenu, MenuSection, NavHeader }
